import { ReplaySubject, connectable, fromEvent, merge } from 'rxjs';
import { map, startWith, take } from 'rxjs/operators';

export const visibilityState$ = connectable(
  merge(fromEvent(window, 'focus').pipe(map(() => 'focus')), fromEvent(window, 'blur').pipe(map(() => 'blur'))).pipe(startWith('')),
  { connector: () => new ReplaySubject(1) }
);

export const visibilityStateOnce$ = visibilityState$.pipe(take(1));

visibilityState$.connect();
